export const state = {
  benchmarksList: {
    isLoading: false,
    hasError: false,
    data: [],
  },
  activeBenchmarksPeriod: null,
  benchmarksUpdate: {
    hasError: false,
    isLoading: false,
  },
};
